 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"apiaries~apiary":"apiaries~apiary","apiaries":"apiaries","apiary":"apiary","apiary-create":"apiary-create","apiary-edit":"apiary-edit","colony-create":"colony-create","colony-edit":"colony-edit","colony~measure-create~measure-edit~note-create~note-edit~rating-archive~rating-create~rating-edit":"colony~measure-create~measure-edit~note-create~note-edit~rating-archive~rating-create~rating-edit","colony":"colony","measure-create~measure-edit~note-create~note-edit~rating-create~rating-edit":"measure-create~measure-edit~note-create~note-edit~rating-create~rating-edit","measure-create~measure-edit":"measure-create~measure-edit","measure-create":"measure-create","measure-edit":"measure-edit","note-create":"note-create","note-edit":"note-edit","rating-create":"rating-create","rating-edit":"rating-edit","rating-archive":"rating-archive","login":"login","password-reset":"password-reset","queen":"queen","queen-create~queen-edit":"queen-create~queen-edit","queen-create":"queen-create","queen-edit":"queen-edit","register":"register","unite_colonies":"unite_colonies","unite_colonies_or_remove_queen":"unite_colonies_or_remove_queen","unite_colonies_or_remove_queen2":"unite_colonies_or_remove_queen2","unite_colonies_or_remove_queen3":"unite_colonies_or_remove_queen3"}[chunkId]||chunkId) + "." + {"apiaries~apiary":"6a971a0c","apiaries":"ba51da77","apiary":"30b22c33","apiary-create":"f378c8b5","apiary-edit":"b495e015","chunk-4754723c":"265d9693","colony-create":"e4b9bd3a","colony-edit":"0b4e71a0","colony~measure-create~measure-edit~note-create~note-edit~rating-archive~rating-create~rating-edit":"0ab234d1","colony":"86ac80a6","measure-create~measure-edit~note-create~note-edit~rating-create~rating-edit":"5e7138fe","measure-create~measure-edit":"7663a453","measure-create":"4f45d6e0","measure-edit":"79c03b41","note-create":"6626a285","note-edit":"95e3beeb","rating-create":"712eb1f3","rating-edit":"24f28637","rating-archive":"fdfe6ded","login":"bd2fb9f8","password-reset":"fdc56ace","queen":"7568d7aa","queen-create~queen-edit":"2ee02afb","queen-create":"fa06ebf3","queen-edit":"2875edba","register":"4240ba80","unite_colonies":"b2402e3c","unite_colonies_or_remove_queen":"78fca1a1","unite_colonies_or_remove_queen2":"a18c341a","unite_colonies_or_remove_queen3":"6c6adb36"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"apiaries~apiary":1,"apiaries":1,"apiary":1,"apiary-create":1,"apiary-edit":1,"chunk-4754723c":1,"colony-create":1,"colony-edit":1,"colony":1,"measure-create~measure-edit":1,"note-create":1,"note-edit":1,"rating-create":1,"rating-edit":1,"rating-archive":1,"login":1,"password-reset":1,"queen":1,"queen-create~queen-edit":1,"register":1,"unite_colonies":1,"unite_colonies_or_remove_queen":1,"unite_colonies_or_remove_queen2":1,"unite_colonies_or_remove_queen3":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"apiaries~apiary":"apiaries~apiary","apiaries":"apiaries","apiary":"apiary","apiary-create":"apiary-create","apiary-edit":"apiary-edit","colony-create":"colony-create","colony-edit":"colony-edit","colony~measure-create~measure-edit~note-create~note-edit~rating-archive~rating-create~rating-edit":"colony~measure-create~measure-edit~note-create~note-edit~rating-archive~rating-create~rating-edit","colony":"colony","measure-create~measure-edit~note-create~note-edit~rating-create~rating-edit":"measure-create~measure-edit~note-create~note-edit~rating-create~rating-edit","measure-create~measure-edit":"measure-create~measure-edit","measure-create":"measure-create","measure-edit":"measure-edit","note-create":"note-create","note-edit":"note-edit","rating-create":"rating-create","rating-edit":"rating-edit","rating-archive":"rating-archive","login":"login","password-reset":"password-reset","queen":"queen","queen-create~queen-edit":"queen-create~queen-edit","queen-create":"queen-create","queen-edit":"queen-edit","register":"register","unite_colonies":"unite_colonies","unite_colonies_or_remove_queen":"unite_colonies_or_remove_queen","unite_colonies_or_remove_queen2":"unite_colonies_or_remove_queen2","unite_colonies_or_remove_queen3":"unite_colonies_or_remove_queen3"}[chunkId]||chunkId) + "." + {"apiaries~apiary":"9167d57c","apiaries":"88b5d66e","apiary":"48d482a5","apiary-create":"0aff78e5","apiary-edit":"0aff78e5","chunk-4754723c":"6be22c9a","colony-create":"ca6c2c47","colony-edit":"ca6c2c47","colony~measure-create~measure-edit~note-create~note-edit~rating-archive~rating-create~rating-edit":"31d6cfe0","colony":"4d4f45d7","measure-create~measure-edit~note-create~note-edit~rating-create~rating-edit":"31d6cfe0","measure-create~measure-edit":"1a81fe92","measure-create":"31d6cfe0","measure-edit":"31d6cfe0","note-create":"c3cb8f26","note-edit":"c3cb8f26","rating-create":"58d4b8f6","rating-edit":"58d4b8f6","rating-archive":"8bee6604","login":"4f762984","password-reset":"76b6fd0c","queen":"2b71368a","queen-create~queen-edit":"25227815","queen-create":"31d6cfe0","queen-edit":"31d6cfe0","register":"a8963d8b","unite_colonies":"e5a5b8a0","unite_colonies_or_remove_queen":"810272f4","unite_colonies_or_remove_queen2":"5d4442c4","unite_colonies_or_remove_queen3":"1e3bd45f"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/portal/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
